import React from 'react'
import Container from '@material-ui/core/Container'
import styleClasses from '../components/common/common.module.scss'
import BlacklistedList from '../components/blacklisted/BlacklistedList'

export default function BlackListedPage({ building, isSecurityUser }) {
  return (
    <main className={styleClasses.content}>
      <Container maxWidth="lg" className={styleClasses.container}>
        <BlacklistedList building={isSecurityUser ? building : null} />
      </Container>
    </main>
  )
}
